module.exports = __webpack_public_path__ + "static/media/cosaic_2.bf95c57c.png";